import {
  getVaSessionUrl,
  getHpIdUrl,
  getHpSmartUrl
} from '@uma/react-commons/dist/index';

export const getCardsInstantInkRequestMoreInk = async (
  language: string = 'en',
  country: string = 'us'
): Promise<string> => {
  return getVaSessionUrl({
    language,
    country,
    botContext: {
      query: 'ii_inkDelivery',
      pageId: 'Home'
    }
  });
};

export const getProliveSupportUrl = (
  language: string = 'en',
  country: string = 'us'
): string =>
  `https://support.hp.com/${country}-${language}/contact/all-in-plan-serial-number`;

export const URLS = {
  Cards: {
    LoginAndSecurity: {
      ChangePassword: `${getHpIdUrl()}/security`,
      UpdatePersonalDetails: `${getHpIdUrl()}/profile`,
      ChangePasswordOnPortal: `/security/password`,
      UpdatePersonalDetailsOnPortal: `/profile`
    },
    YourPurchases: {
      ViewOrderHistory:
        'https://www.hp.com/us-en/shop/MyOrdersView?catalogId=10051&langId=-1&storeId=10151',
      StartReturn:
        'https://www.hp.com/us-en/shop/cv/returnsandexchanges?pStoreID=hpepp'
    },
    InstantInk: {
      UpdatePaymentMethod: `${getHpSmartUrl()}/account-details/shipping-billing`,
      ManagePlan: `${getHpSmartUrl()}/print_plans/my_account`,
      ViewPrintUsage: `${getHpSmartUrl()}/print_plans`
    },
    HpAllIn: {
      UpdatePaymentMethod: `${getHpSmartUrl()}/account-details/shipping-billing`,
      ManagePlan: `${getHpSmartUrl()}/hp-all-in-print-plan/update-plan`,
      ViewPrintUsage: `${getHpSmartUrl()}/hp-all-in-print-plan/overview`
    },
    OtherLinks: {
      PrinterShowsAccountIssue: `${getHpSmartUrl()}/account-details/view-notifications`,
      AddPrinter: `${getHpSmartUrl()}/my-printers`,
      GetProductSupport: `https://support.hp.com`,
      RegisterDevice: `https://www.register.hp.com/`
    }
  }
};
